module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 753
// module chunks = 1